// This is only used for validation, it does not build based on these fields.  Just used to ensure that all the fields are filled out
export default {
	rows: [{
		property: 0,
		lot_type: 0,
		builder: "",
		email: "",
		zip: "",
		host: null,
		first_name: "",
		last_name: "",
		source: "",
		neighborhood:null,
		traffic_date:0,
		is_realtor: 0,
		realtor: '',
		realtor_phone: '',
		realtor_office: '',
		no_first: false,
		no_last: false,
		no_email: false,
		street: "",
		how_much: "",
		timeframe: "",
		city: "",
		state: "",
		section_id: "",
		addl: {}
	}]
}